import type { Town, TownData } from '@/game/types';
import type { TownLayoutPayload } from '@/modules/game-domain/authored-town.types';
import { displayName } from '@/i18n/displayName';
import type { Locale } from '@/i18n/localeCodes';
import { authoredTownGeometry } from './authored-town-geometry';

export { authoredBuildingFamily, authoredPropType } from './authored-town-geometry';

/** Game labels are localized outside the shared game/editor geometry boundary. */
export function authoredTownToTownData(town: Town, payload: TownLayoutPayload, locale: Locale): TownData {
  const mapped = authoredTownGeometry(town, payload);
  return {
    ...mapped,
    name: displayName(locale, 'town', town),
    npcs: mapped.npcs?.map(npc => ({
      ...npc, name: displayName(locale, 'npc', npc),
    })),
  };
}
